import React, {useState} from 'react'
import _ from 'lodash'
import { Search } from 'semantic-ui-react'
import PropTypes from "prop-types";

const SearchList = ({items})=>{
    const [searchResults, setSearchResults] = useState({})
    const handleSearchChange = value => {
        const re = new RegExp(_.escapeRegExp(value), 'i')
        const isMatch = (result) => re.test(result.title)
        const filteredResults = _.reduce(items, (memo, data, name) => {
            const results = _.filter(data.results, isMatch)
            if (results.length) memo[name] = { name, results }
            return memo
        }, {})
        setSearchResults(filteredResults)
    }
    const resultRenderer = ({ title, path }) => {
        return <a className="content" href={path} >
            <div className="title">{title}</div>
        </a>
    }

    resultRenderer.propTypes = {
        title: PropTypes.string,
        path: PropTypes.string,
    }
      

    return (
        <Search category results={searchResults} size="small" minCharacters={2}
            onSearchChange={_.debounce((e, { value }) => handleSearchChange(value), 500, { leading: true })}
            onResultSelect={(e, { result }) => window.location = result.path}
            resultRenderer={resultRenderer}
        />
    )
}
SearchList.propTypes = {
    items: PropTypes.object
}
export default SearchList;